import React, {useRef, useState} from 'react';
//import {fetchUserFriends} from "../../creators/user.friends";
import {Button} from "./Button";
import {Can} from "../../ability-context";
import CtaCannot from "./CtaCannot";
import {fetchUserFriends, USER_CURRENT_KEY, USER_FRIENDS_KEY} from "../../api/public-voissa/users";
import _ from "lodash";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import loadable from "@loadable/component";

const SimpleEditor = loadable(() => import("./editor/SimpleEditor"));

const InputPost = ({
       sendBtnIcon = false,
       sendBtn = false,
       btnContent = "",
       placeholder = "",
       contentRaw = "",
       editorStyle = "",
       loading = false,
       error = false,
       canOptions = {},
       handleSubmit = () => {}
    }) =>{

    const queryClient = useQueryClient();

    const [currentContentRaw, setCurrentContentRaw] = useState(contentRaw || "");

    canOptions = {
        action : "create",
        subject : {},
        modelName : "Comment",
        passThrough : true,
        ...canOptions
    };
    let editorRef = useRef();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    const {data : dataFriends} = useQuery(
        [USER_FRIENDS_KEY, _.get(dataCurrentUser, '_id'), {limit: false}],
        ()=> fetchUserFriends(_.get(dataCurrentUser, '_id'), {limit: false}),
        {
            staleTime : (1000 * 60 * 5),
            enabled : !!isCurrentUser,
            placeholderData : {
                data : [],
                total : 0
            },
            select : (data) =>{
                return {
                    friends : data.data || [],
                    total : data.total
                }
            }
        }
    );

    let {friends = []} = dataFriends || {};

    function _handleSubmit(event){
        if(event){
            event.preventDefault();
            event.stopPropagation();
        }

        setTimeout(()=>{
            if(typeof handleSubmitMessageTimeout === "function"){
                handleSubmitMessageTimeout();
            }
        },50)
    }

    function handleSubmitMessageTimeout() {
        let hasText = editorRef.current.handleHasText();
        if(hasText){
            handleSubmit({contentRaw: currentContentRaw}, editorRef.current.hasCustomMention());
            if(editorRef.current){
                setCurrentContentRaw(editorRef.current.getRaw());
                editorRef.current.handleClear();
            }
        }
    }

    return (
        <div className="message-container row align-center px-8">
            <form className="message-input-wrapper" onSubmit={(event) => _handleSubmit(event)}>
                <SimpleEditor
                    onChange={(contentRaw) => setCurrentContentRaw(contentRaw)}
                    ref={editorRef}
                    userFriends={friends}
                    editorStyle={editorStyle}
                    placeholder={placeholder}
                    defaultValue={currentContentRaw}
                />

                <Can {...canOptions}>
                    {can=>{
                        return can ? (
                            <>
                                {sendBtnIcon && (
                                    <Button
                                        className={"sendBtnIcon"}
                                        size={"small"}
                                        icon={"paper-plane"}
                                        loading={loading}
                                        btnType={"submit"}/>
                                )}
                                {sendBtn && (
                                    <Button
                                        className={"sendBtn"}
                                        size={"medium"}
                                        btnStyle={"primary-reverse"}
                                        loading={loading}
                                        btnType={"submit"}
                                        content={btnContent}/>

                                )}
                                {error && (
                                    <div className={"input-error"}>{error}</div>
                                )}
                            </>
                        ) : (
                            <div className={"w-100 flex-end"}>
                                <CtaCannot
                                    action={ canOptions.subject === "Status" ? "createStatus" : "createComment"}
                                    isModal={true}
                                    disabled={editorRef.current && !editorRef.current.handleHasText()}
                                >
                                    {sendBtnIcon && (
                                        <Button
                                            className={"sendBtnIcon"}
                                            size={"small"}
                                            icon={"paper-plane"}
                                            loading={loading}
                                            btnType={null}
                                            disabled={editorRef.current && !editorRef.current.handleHasText()}
                                        />
                                    )}
                                    {sendBtn && (
                                        <Button
                                            className={"sendBtn"}
                                            size={"medium"}
                                            btnStyle={"primary-reverse"}
                                            loading={loading}
                                            btnType={null}
                                            content={btnContent}
                                            disabled={editorRef.current && !editorRef.current.handleHasText()}
                                        />
                                    )}
                                </CtaCannot>
                            </div>
                        )}}
                </Can>
            </form>
        </div>
    )
};

export default InputPost;